import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import FinancialUnderwritingForm from "./indexForm";
// import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import { Box } from "@mui/material";
import {
  getRoute,
  getStorageItem,
  makeid,
  setStorageItem,
} from "../../../helpers/utils";
import { useHistory } from "react-router";
import { postWebService } from "../../../helpers/server";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import { SLUG_TERM_PRODUCT, SLUG_TROP_PRODUCT } from "../../../constants";

const TERM_PRODUCT_SLUG = "signature-3d";

function FinancialUnderwriting({ classes: { loaderBox, main } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [form, setForm] = useState({ ITR: "YES" });
  const [backdrop, setBackdrop] = useState(false);
  const [errors, setErrors] = useState([]);
  const [modal, setModal] = useState({ open: false, snackbar: false });
  const [isLoaded, setIsLoaded] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [backDrop, setBackDrop] = useState(true);
  const [selectedDocumentType, setSelectedDocumentType] = useState("ITR");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [resendLink, setResendLink] = useState(false);
  const [itrPopup, setItrPopup] = useState(false);
  const [itr_filled, setItrFilled] = useState("YES");
  const [itrBlock, setItrBlock] = useState({
    options: true,
    itr_link: false,
  });

  const [block, setBlock] = useState({
    options: true,
    itr_link: false,
  });

  const [options] = useState({
    itr: [
      { title: "YES", value: "YES" },
      { title: "NO", value: "NO" },
    ],
  });
  const [itrNotFilledMessage] = useState(
    "The journey has been terminated because the customer has not filed an Income Tax Return (ITR). Filing and submission of ITR details is mandatory for customers whose credit score and income score fall below the prescribed threshold."
  );
  const [cibilErrorMessage, setCibilErrorMessage] = useState(
    "CIBIL failed due to annual income/score below threshold limit."
  );

  useEffect(() => {
    wrapperToken();
  }, []);

  const wrapperToken = async () => {
    try {
      const header = buildWrapperTokenHeader();
      const response = await postWebService("token.php", {}, header);

      setStorageItem("access-token", response.data.access_token);
      getOrder();
    } catch (error) {
      // console.log(error);
    }
  };

  const getOrder = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("orders.php", {
        checksum,
        oid: getStorageItem("oid"),
      });
      const { data } = response;
      setBackdrop(false);
      const str = data.data.slice(9, -8);
      const result = JSON.parse(atob(str));
      if (result.checksum === checksum) {
        setCibilErrorMessage(
          result?.cibil_criteria_score === "0"
            ? "CIBIL failed due to annual income below threshold limit."
            : "CIBIL failed due to annual income / credit score below threshold limit."
        );
        setOrderDetails(result);
        toggleBlock(result?.itr_link_status ? "itr_link" : "options", true);
        setIsLoaded(true);
      }
    } catch (error) {
      setBackdrop(false);
    }
  };

  const sendITRLink = async (flag = false) => {
    setErrorMessage(null);
    setBackDrop(true);
    setIsFormSubmitted(true);
    setResendLink(flag);

    const response = await postWebService("start-itr.php", {
      oid: getStorageItem("oid"),
      checksum: makeid(),
      cid: getStorageItem("cid"),
      pid: getStorageItem("pid"),
      timestamps: Math.floor(Date.now() / 1000),
    });
    const { data } = response;

    setIsFormSubmitted(false);
    if (data?.error === "unauthorized") {
      wrapperToken();
      setErrorMessage("Unable to send ITR link. Please try again.");
    } else {
      toggleBlock("itr_link", true);
    }
  };

  const checkITRStatus = async () => {
    setIsFormSubmitted(true);
    setErrorMessage(null);
    const checksum = makeid();
    const response = await postWebService("checkitrstatus.php", {
      oid: getStorageItem("oid"),
      checksum,
    });

    const { data } = response;

    setIsFormSubmitted(false);
    if (data?.checksum === checksum) {
      const status = data?.status ?? 400;
      const message =
        data?.message ?? "Unable to fetch ITR status. Please try again.";
      if (status === 200) {
        getStorageItem("productSlug") === TERM_PRODUCT_SLUG
          ? navigateTo("regenerateBI")
          : navigateTo("bankDetails");
      } else if (status === 422) {
        setErrorMessage(message);
      } else {
        terminateClickHandler(message);
      }
    } else {
      setErrorMessage(
        data?.message ?? "Unable to fetch ITR status. Please try again."
      );
    }
  };

  const terminateClickHandler = (message = "") => {
    setStorageItem("journeyCloseReason", message);
    navigateTo("terminated");
  };

  const toggleBlock = (key = "", value = false) => {
    const newBlock = { ...block, options: false, itr_link: false }; // shallow copy
    newBlock[key] = value; // update the key

    setBlock(newBlock);
  };

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const changeChipSelect = (field, value) => {
    if (field === "itr_filled") setItrFilled(value);
  };

  // const isDedupeEnabled = () => orderDetails?.productSlug === SLUG_TROP_PRODUCT;

  const isDedupeEnabled = () => {
    return true;
  };

  const getPathName = (pathname = "bankDetails") =>
    isDedupeEnabled() && pathname === "bankDetails" ? "dedupe" : pathname;

  const navigateTo = (url = "bankDetails") => {
    url = getPathName(url);

    history.push({ pathname: getRoute(url) });
  };

  const handleChangeOption = () => toggleBlock("options", true);

  return isLoaded ? (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1} mb={0}>
          <SectionTitle title={"Financial Underwriting"} />
        </Box>

        <FinancialUnderwritingForm
          block={block}
          changeChipSelect={changeChipSelect}
          checkITRStatus={checkITRStatus}
          cibilErrorMessage={cibilErrorMessage}
          errors={errors}
          errorMessage={errorMessage}
          form={form}
          modal={modal}
          isFormSubmitted={isFormSubmitted}
          itrBlock={itrBlock}
          itr_filled={itr_filled}
          orderDetails={orderDetails}
          options={options}
          sendITRLink={sendITRLink}
          resendLink={resendLink}
          handleChangeOption={handleChangeOption}
          itrNotFilledMessage={itrNotFilledMessage}
          terminateClickHandler={terminateClickHandler}
        />
      </Box>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  FinancialUnderwriting
);
